import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyAZP2T96k5WxLkVfB8-EUrrj-JiGay73_Q",
  authDomain: "swe-intern-db.firebaseapp.com",
  projectId: "swe-intern-db",
  storageBucket: "swe-intern-db.firebasestorage.app",
  messagingSenderId: "489741012013",
  appId: "1:489741012013:web:ccd5132dc9e59271283ca4"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);

export { app, db, auth };
